/**
 * Admin API
 * Admin REST API
 *
 * OpenAPI spec version: 1.0
 * Contact: ti@b4agroup.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export interface ItauCalendarioRecorrencia {
  dataFinal?: string;
  dataInicial: string;
  periodicidade?: ItauCalendarioRecorrencia.PeriodicidadeEnum;
}
export namespace ItauCalendarioRecorrencia {
  export type PeriodicidadeEnum =
    | 'SEMANAL'
    | 'MENSAL'
    | 'TRIMESTRAL'
    | 'SEMESTRAL'
    | 'ANUAL';
  export const PeriodicidadeEnum = {
    SEMANAL: 'SEMANAL' as PeriodicidadeEnum,
    MENSAL: 'MENSAL' as PeriodicidadeEnum,
    TRIMESTRAL: 'TRIMESTRAL' as PeriodicidadeEnum,
    SEMESTRAL: 'SEMESTRAL' as PeriodicidadeEnum,
    ANUAL: 'ANUAL' as PeriodicidadeEnum
  };
}
